import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src584700147/src/src/app/ui/common/side-menu.tsx");
